<template>
  <v-layout row justify-center>
    <v-dialog v-model="$store.state.moreBtnStore.moreBtnIsumTuneModal" width="400px">
      <v-card>
        <v-card-title class="headline">ISUM曲のコード入力</v-card-title>
        <v-card-text>
          <p class="red--text" v-show="!$store.state.customerInfo.isum_bring_flg">※ 原盤を会場へ必ずお持ち込み願います</p>
          <p>
            ISUMサイトから使用されたい曲のISUMコードをお調べの上、ご入力ください。<br>
            ISUM公式サイト：<a href="https://isum.or.jp/music/" target="_brank">https://isum.or.jp/music/</a>
          </p>
          <p>
            記録ビデオにも収録する場合、盤での納品に限ります（クラウド納品には未対応）。また<span class="red--text">別途でISUM申請料</span>を頂戴します。<br>
            当日のBGMのみで使用の場合、記録ビデオを注文の際は、フリーBGMに挿し替わります。
          </p>
          <v-radio-group v-model="isumType" column>
            <v-radio label="記録ビデオにも収録(申請料)"
                     color="orange"
                     value="1">
            </v-radio>
            <v-radio label="当日のBGMのみで使用"
                     color="orange"
                     value="2">
            </v-radio>
          </v-radio-group>
          <v-text-field
            name="isumcode"
            label="例）ISUM-0000-0000"
            v-model="isumCode"
            single-line
          ></v-text-field>
          <p v-show="isNotExistDuplicationIsumTuneFlag === false" class="warn-text">プレイリストに重複するISUM楽曲が存在しています。</p>
          <v-text-field
            name="isum-tune"
            label="楽曲"
            v-model="isumTune"
            single-line
          ></v-text-field>
          <v-text-field
            name="isum-artist"
            label="アーティスト名"
            v-model="isumArtist"
            single-line
          ></v-text-field>
        </v-card-text>
        <v-card-actions v-if="canNotAddSong" class="more-btn-isum-tune-modal__error-message-container">
          <p class="error-text">使用できる回数の上限に達しているため追加出来ません。</p>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancel">キャンセル</v-btn>
          <v-btn color="green darken-1" :disabled="!formIsValid || canNotAddSong" flat="flat" @click="saveCode">追加</v-btn>
        </v-card-actions>
        <div style="height:80px;"></div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import IsumService from '@/components/services/IsumService.vue'
export default {
  name: 'MoreBtnIsumTuneModal',
  data () {
    return {
      itemIndex: null,
      isumDialog: false,
      isumType: null,
      isumCode: null,
      isumArtist: null,
      isumTune: null,
      isNotExistDuplicationIsumTuneFlag: true,
      customerPlaylistProductId: null,
      playListType: null
    }
  },
  mounted () {
    this.setIsumTuneParam()
  },
  watch: {
    isumCode (val) {
      if (val) {
        IsumService.isNotExistDuplicationIsumTune(this.isumCode, this.playListType, this.itemIndex, (response) => {
          if (response) {
            this.isNotExistDuplicationIsumTuneFlag = true
          } else {
            this.isNotExistDuplicationIsumTuneFlag = false
          }
        })
      }
    }
  },
  computed: {
    canNotAddSong () {
      // isumコードを持つIndexの場合、修正のために追加を許可する
      if (this.hasIsumCode()) return false
      if (this.$store.getters.getIsumLimit) {
        return this.$store.getters.getIsumTuneInPlayListCount >= this.$store.getters.getIsumLimit
      } else {
        return false
      }
    },
    /**
     * formの値を確認する。すべて入力されているかを確認
     **/
    formIsValid () {
      return (
        this.isumCode &&
        this.isumType &&
        this.isumTune &&
        this.isumArtist
      )
    }
  },
  methods: {
    setIsumTuneParam () {
      let modalParam = this.$store.getters.getMoreBtnModalParam
      this.customerPlaylistProductId = modalParam.moreBtnCustomerPlaylistProductId
      this.playListType = modalParam.moreBtnPlayListType
      this.itemIndex = modalParam.moreBtnItemIndex
      let isumInfoSet = this.$store.getters.getIsumTuneInfo(modalParam.moreBtnPlayListType, modalParam.moreBtnItemIndex)
      this.isumType = isumInfoSet.isumType
      this.isumCode = isumInfoSet.isumCode
      this.isumArtist = isumInfoSet.isumArtist
      this.isumTune = isumInfoSet.isumTune
    },
    addIsum: function () {
      this.isumDialog = true
    },
    /**
     * Isum曲をプレイリストに追加する
     **/
    saveCode: function () {
      let transactionId = this.$store.state.transactionId
      let formData = new URLSearchParams()
      formData.append('product_id', this.getIsumProductId())
      formData.append('customer_playlist_product_id', this.customerPlaylistProductId)
      formData.append('isum_code', this.isumCode)
      formData.append('isum_type', this.isumType)
      formData.append('isum_song_name', this.isumTune)
      formData.append('isum_artist_name', this.isumArtist)
      formData.append('other_song_name', ' ')
      formData.append('other_artist_name', ' ')
      formData.append('transactionid', transactionId)
      CustomerPlayListService.updatePlayListTune(formData, (response) => {
        this.$log.debug(response)
        this.$store.dispatch('switchMoreBtnIsumTuneModalFlag', false)
        CustomerPlayListService.findCustomerPlayList(this.playListType, transactionId, (response) => {
        }, (error) => {
          this.$log.error(error)
        })
      }, (error) => {
        this.$log.error(error)
      })
      this.isumDialog = false
    },
    cancel () {
      this.$store.dispatch('switchMoreBtnIsumTuneModalFlag', false)
    },
    hasIsumCode () {
      let result = false
      if (this.$store.getters.getIsumTuneByPlayListIdAndIndex(this.playListType, this.itemIndex)) {
        result = true
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
  .more-btn-isum-tune-modal__error-message-container{
    padding: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MoreBtnIsumTuneModal.vue